'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var Analytics = _interopDefault(require('../global/analytics.js'));
var CarouselBase = _interopDefault(require('./carousel-base.js'));
require('./jquery.preparetransition.js');

var Carousel = function (_CarouselBase) {
  _inherits(Carousel, _CarouselBase);

  /**
   * Simple JS carousel. Does not show/hide elements, just adds and removes classes.
   * @param {$DOM} el Element wrapper
   * @param {Object} [options] configuration options
   * @param {String} [options.duration=5000] length between slides when autoplaying (milliseconds)
   * @class Carousel
   * @namespace ShopifyMarketing
   * @constructor
  */
  function Carousel(el, options) {
    _classCallCheck(this, Carousel);

    var carouselOptions = _Object$assign({
      carouselItem: '.carousel-item',
      carouselNavItem: '.carousel-nav-item'
    }, options);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || _Object$getPrototypeOf(Carousel)).call(this, el, carouselOptions.carouselItem, carouselOptions));

    _this.$navItems = _this.$el.find(carouselOptions.carouselNavItem);

    if (_this.itemsCount > 1) {
      _this.nextIndex = _this.currentIndex + 1;
      _this.prevIndex = _this.itemsCount - 1;
    } else {
      _this.nextIndex = 0;
      _this.prevIndex = 0;
    }

    _this._onClick = _this._onClick.bind(_this);
    _this._navNext = _this._navNext.bind(_this);
    _this._navPrev = _this._navPrev.bind(_this);
    _this._loop = _this._loop.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.prev = _this.prev.bind(_this);
    _this.start = _this.start.bind(_this);
    _this.stop = _this.stop.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);

    _this.$el.on('click', carouselOptions.carouselNavItem, _this._onClick);
    _this.$el.on('click', '.carousel-arrow-left', _this._navPrev);
    _this.$el.on('click', '.carousel-arrow-right', _this._navNext);

    _this.goToIndex(_this.currentIndex);
    return _this;
  }

  /**
   * Transitions to specific slide, and updates the currentIndex/nextIndex/
   * prevIndex properties to facilitate looping.
   * @method goToIndex
   * @param {Integer} target slide index (0-indexed)
   * @return {$ DOM element} newly active element
  */


  _createClass(Carousel, [{
    key: 'goToIndex',
    value: function goToIndex(index) {
      var lastIndex = this.currentIndex;

      if (index >= this.itemsCount) {
        this.currentIndex = 0;
      } else if (index < 0) {
        this.currentIndex = this.itemsCount - 1;
      } else {
        this.currentIndex = index;
      }

      this.nextIndex = this.currentIndex + 1 < this.itemsCount ? this.currentIndex + 1 : 0;
      this.prevIndex = this.currentIndex - 1 >= 0 ? this.currentIndex - 1 : this.itemsCount - 1;

      this.$navItems.removeClass('js-is-active');
      this.$items.removeClass('js-is-active js-was-active');

      if (lastIndex !== this.currentIndex) {
        this.$items.eq(lastIndex).addClass('js-was-active');
      }

      this.$items.eq(this.currentIndex).prepareTransition().addClass('js-is-active');

      this.$el.attr('data-state', this.currentIndex).trigger('change', this.currentIndex);

      return this.$navItems.eq(this.currentIndex).addClass('js-is-active');
    }
  }, {
    key: '_navPrev',
    value: function _navPrev(evt) {
      evt.preventDefault();
      this.stop();
      this._track();
      return this.prev();
    }
  }, {
    key: '_navNext',
    value: function _navNext(evt) {
      evt.preventDefault();
      this.stop();
      this._track();
      return this.next();
    }
  }, {
    key: '_onClick',
    value: function _onClick(evt) {
      evt.preventDefault();
      var state = evt.currentTarget.getAttribute('data-state');
      this.goToIndex(~~parseInt(state, 10));
      this._track();
      return this.stop();
    }
  }, {
    key: '_track',
    value: function _track() {
      var label = void 0;

      // Send carousel nav item text if present, otherwise send humanized
      // currentIndex
      if (this.$navItems.eq(this.currentIndex).text() === '') {
        label = this.currentIndex + 1;
      } else {
        label = this.$navItems.eq(this.currentIndex).text();
      }

      Analytics.track('carousel', this.$el.prop('id'), label);
    }
  }]);

  return Carousel;
}(CarouselBase);

module.exports = Carousel;
